import React, { useState } from "react";
import Modal from "../Modal";
import { useDispatch } from "react-redux";

const DeletePost = ({ setUpdateState, handleDelete }) => {
  const [reason, setReason] = useState("");
  const [errors, setErrors] = useState({}); // State to track errors
  const dispatch = useDispatch();

  const handleClose = () => {
    setUpdateState((prev) => ({
      ...prev,
      deletePost: false,
    }));
  };

  const validateForm = () => {
    let formErrors = {};
    if (!reason?.trim()) {
      formErrors.reason = "Reason is required"; // Error message for empty reason
    }
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0; // Returns true if no errors
  };

  const handleDeletePost = () => {
    if (validateForm()) {
      // Only call handleDelete if validation passes
      handleDelete(reason);
    }
  };

  return (
    <Modal>
      <div className="modal-body">
        <div className="Category">
          <a className="CloseModal" onClick={handleClose}>
            ×
          </a>
          <h3>Delete Post</h3>
          <div className="form-group">
            <label>Enter reason to remove the post</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter the reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
            {errors.reason && (
              <p className="d-flex justify-content-start text-danger mt-2">
                {errors.reason}
              </p>
            )}
          </div>
          <button className="Button" onClick={handleDeletePost}>
            Send Notification to User
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeletePost;
